export default __webpack_public_path__ + "static/ledger@2x-ae57d1af1d53fa33dcff77faff22f3ef.png";